import React, { useEffect, useState } from 'react'

import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { TrackButton } from 'artkive/components/Tracker'
import { GET_BOX_CLICK } from 'artkive/constants/tracker/mainNavigation'
import usePromo from 'artkive/hooks/usePromo'
import {
  getEmbedFormIdToDisplay,
  getKlaviyoArtkiveProperties,
  isPopupFormSubmitted,
  klaviyoFormClass,
} from 'artkive/utils/klaviyoHelpers'
import routes from 'artkive/utils/routes'

import EmbedForm from 'images/ecom/home/EmbedForm.png'

const useStyles = makeStyles((theme) => ({
  embedFormWrap: {
    backgroundColor: '#17308b',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    zIndex: 101,
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  imageWrap: {
    background: `center 50% / cover no-repeat url("${EmbedForm}")`,
    width: '100%',
    height: '280px',
    order: -1,
    [theme.breakpoints.up('md')]: {
      width: '50%',
      height: 'auto',
      order: 1,
    },
  },
  formWrap: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    padding: '32px 0',
    minHeight: '402px',
    [theme.breakpoints.up('md')]: {
      width: '50%',
      padding: '40px 58px 40px 0',
      justifyContent: 'flex-end',
    },
  },
  successWrap: {
    display: 'flex',
    maxWidth: '450px',
    padding: '10px 16px',
  },
  successForm: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minHeight: '240px',
  },
  title: {
    color: 'white',
    padding: '10px 3px 0px',
    textAlign: 'center',
  },
  subtitle: {
    color: 'white',
    padding: '20px 20px 0px',
    textAlign: 'center',
    fontWeight: 400,
  },
  buttonWrap: {
    padding: '24px 6px 10px',
    width: '100%',
  },
}))

const EmailListForm = () => {
  const classes = useStyles()
  const { promoState: { email, phoneNumber } } = usePromo({})

  const [embedFormId, setEmbedFormId] = useState(null)
  const [shouldShowSuccess, setShouldShowSuccess] = useState(false)

  useEffect(() => {
    const id = getEmbedFormIdToDisplay()
    setEmbedFormId(id)
  }, [])

  useEffect(() => {
    // NOTE: Will update embed form immediately on adding email in the POPUP form
    if (!email || phoneNumber) return

    const embedPhoneFormId = getKlaviyoArtkiveProperties()?.klaviyoEmbedPhoneFormId
    setEmbedFormId(embedPhoneFormId)
  }, [email, phoneNumber])

  useEffect(() => {
    const isPopupSubmitted = isPopupFormSubmitted()
    if (isPopupSubmitted || !phoneNumber) return
    setShouldShowSuccess(true)

    const embedElement = document.querySelector(`form[data-testid="${klaviyoFormClass}-${embedFormId}"]`)
    if (!embedElement) return
    embedElement.style.display = 'none'
  }, [phoneNumber, embedFormId])

  if (!embedFormId) return null

  return (
    <div className={classes.embedFormWrap}>
      <div className={classes.formWrap}>
        {shouldShowSuccess ? (
          <div className={classes.successWrap}>
            <div className={classes.successForm}>
              <Typography variant={'h1'} className={classes.title}>You're In!</Typography>
              <Typography variant={'body1'} className={classes.subtitle}>
                Check your messages for your $15, or head straight to checkout to auto-apply.
              </Typography>
              <div className={classes.buttonWrap}>
                <TrackButton
                  color={'primary'}
                  variant={'contained'}
                  href={routes.boxCheckout}
                  trackerEvent={GET_BOX_CLICK}
                  trackerOptions={{ section: 'klaviyo_embed_form' }}
                  size={'large'}
                  style={{ width: '100%', fontWeight: 600 }}
                >
                  Get My Box
                </TrackButton>
              </div>
            </div>
          </div>
        ) : (
          <div className={`${klaviyoFormClass}-${embedFormId}`}></div>
        )}
      </div>
      <div className={classes.imageWrap} />
    </div>
  )
}

export default EmailListForm
